import React from "react";
import Footer from "../../modules/page/footer";
import Header from "../../modules/page/header";
import Contact from "../../modules/page/contact";
import "./style.css";

function Page(props) {

  return (
    <>
      <Header></Header>
      <Contact></Contact>
      <Footer></Footer>
    </>
  );
}

export default Page;
